'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Image", {
    enumerable: true,
    get: function() {
        return Image;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderImage = require("./renderImage");
const _useImage = require("./useImage");
const _useImageStylesstyles = require("./useImageStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Image = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useImage.useImage_unstable)(props, ref);
    (0, _useImageStylesstyles.useImageStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useImageStyles_unstable')(state);
    return (0, _renderImage.renderImage_unstable)(state);
});
Image.displayName = 'Image';
